import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveLifestyleSelectedOptions as resolveOptions,
  resolveLifestyleOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_clear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_clear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_dark_grey_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_dark_grey_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_black_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_navy_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_navy_{nnn}.png',
    },
    blacktortoise: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_Black_Tortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_Black_Tortoise_{nnn}.png',
    },
    carbon: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_carbon_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_carbon_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_stone_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_stone_{nnn}.png',
    },
    tortoise: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_tortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_tortoise_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgf_white_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgf_white_{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_black_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_black_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_blue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_gold_{nnn}.png',
    },
    Bgreen: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_green_{nnn}.png',
    },
    Bpurple: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_purple_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_purple_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_red_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_red_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_silver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_silver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgi_white_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgi_white_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/241129/rgi_Brosegold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/241129/rgi_Brosegold_{nnn}.png',
    },
    Borange: {
      pathTemplate: 'gs://sg360/260811/rgi_orange_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260811/rgi_orange_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    blue: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_blue_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_fire_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_fire_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_gold_{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_green_{nnn}.png',
    },
    purple: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_purple_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_purple_{nnn}.png',
    },
    red: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_red_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_red_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_silver_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_silver_blue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_smoke_{nnn}.png',
    },
    brown: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_brown_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_brown_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/270624/Renegades/rgle_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/270624/Renegades/rgle_clear_{nnn}.png',
    },
    water: {
      pathTemplate: 'gs://sg360/250530/Renegades/rgle_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250530/Renegades/rgle_blue_{nnn}.png',
    },
  },
}

export const reflection = {
  id: 'reflections',
  isReflection: true,
  name: 'Reflections',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    r5pc: {
      pathTemplate: 'gs://sg360/031221/rgle_reflection/rgle_Cloud Opacity 5_{nnn}.png',
    },
    r10pc: {
      pathTemplate: 'gs://sg360/031221/rgle_reflection/rle_Cloud Opacity 10_{nnn}.png',
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Renegades/rglg/rglg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/220520/Renegades/rglg/rglg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/220520/Renegades/rglg/rglg_8_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/220520/Renegades/rglg/rglg_8P_{nnn}.png',
    },
    e8W: {
      pathTemplate: 'gs://sg360/130625/Renegades/rglg/rglg_8W_{nnn}.png',
    },
    e8PW: {
      pathTemplate: 'gs://sg360/130625/Renegades/rglg/rglg_8PW_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250530/Renegades/renegades_shadow_{nnn}.png',
    },
  },
}

export default {
  layers: [background, frame, icons, lenses, engraving, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
